import React from 'react';

export const initialSessionState = {
  user: {},
  homepagePreference: '/',
  isUserStateLoading: true
};

export default React.createContext({
  session: initialSessionState,
  dispatch: () => {}
});
